import React, { useState } from "react";
import styled from "styled-components";
import api from "../services/api";
import { toast } from "react-toastify";

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

const Box = styled.div`
  background: white;
  padding: 35px;
  border-radius: 18px;
  width: 420px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
`;

const Title = styled.h2`
  margin-bottom: 15px;
  color:#1e293b;
`;

const Info = styled.p`
  margin:5px 0;
  color:#475569;
`;

const Select = styled.select`
  width:100%;
  padding:12px;
  border-radius:10px;
  border:1px solid #e2e8f0;
  margin-top:15px;
  font-size:14px;

  &:focus{
    outline:none;
    border-color:#3b82f6;
  }
`;

const Buttons = styled.div`
  margin-top:25px;
  display:flex;
  justify-content:flex-end;
  gap:10px;
`;

const Button = styled.button`
  padding:10px 18px;
  border-radius:10px;
  border:none;
  cursor:pointer;
  font-weight:600;
  font-size:13px;
  transition:.2s;

  background:${p=>p.primary ? "#16a34a" : "#e2e8f0"};
  color:${p=>p.primary ? "white" : "#334155"};

  &:hover{
    transform:scale(1.03);
  }
`;

export default function PagamentoModal({ mensalidade, onClose, onSuccess }) {

  const [forma,setForma] = useState("DINHEIRO");
  const [loading,setLoading] = useState(false);

  const pagar = async ()=>{

    try{

      setLoading(true);

      await api.post("/pagamentos/pagar",{
        mensalidade_id: mensalidade.mensalidade_id,
        valor_pago: Number(mensalidade.valor_final),
        forma_pagamento: forma
      });
      toast.success("Pagamento efetuado com sucesso!");
      onSuccess();

    }catch(err){

      alert(err.response?.data?.erro || "Erro ao pagar");

    }finally{
      setLoading(false);
    }

  };

  return (
    <Overlay>

      <Box>

        <Title>Pagar Mensalidade</Title>

        <Info><strong>Aluno:</strong> {mensalidade.aluno_nome}</Info>

        <Info>
          <strong>Valor:</strong> MZN {Number(mensalidade.valor_final).toLocaleString()}
        </Info>

        <Select
          value={forma}
          onChange={e=>setForma(e.target.value)}
        >
          <option value="DINHEIRO">Dinheiro</option>
          <option value="MPESA">M-Pesa</option>
          <option value="EMOLA">E-Mola</option>
          <option value="POS">POS</option>
          <option value="TRANSFERENCIA">Transferência</option>
        </Select>

        <Buttons>
          <Button onClick={onClose}>Cancelar</Button>
          <Button primary onClick={pagar}>
            {loading ? "Processando..." : "Confirmar Pagamento"}
          </Button>
        </Buttons>

      </Box>

    </Overlay>
  );
}